export const SmsFormTypes = Object.freeze({
    "email": "internal_email",
    "sms": "customer_sms",
    "normal": "Normal",
    "certificado": "Certificado",
    "email_customer": "external_email",
    "default": null
})

export const SmsFormTypeIds = Object.freeze({
    "sms": 1,
    "internal_email": 2,
    "external_email": 3
})